var _rect, _line, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStudent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "student",
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6655",
    "data-name": "Rectangle 6655",
    width: 22,
    height: 22,
    fill: "none"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    id: "Line_112",
    "data-name": "Line 112",
    y2: 7,
    transform: "translate(3 6)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_64734",
    "data-name": "Path 64734",
    d: "M54.2,179.515a7.709,7.709,0,0,1,12.915,0",
    transform: "translate(-49.458 -160.615)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_64735",
    "data-name": "Path 64735",
    d: "M48.8,34.8l-8.4,2.8L32,34.8,40.4,32Z",
    transform: "translate(-29.2 -29.2)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_64736",
    "data-name": "Path 64736",
    d: "M80.513,82.2a4.9,4.9,0,1,1-7.227,0",
    transform: "translate(-65.7 -75.008)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStudent);
export default __webpack_public_path__ + "static/media/student.4dd872755d9f487603a26ac7c027ed4f.svg";
export { ForwardRef as ReactComponent };